import { Component, OnInit } from '@angular/core';

import { first } from "rxjs/operators";
import { LigneFinancement } from "src/app/parametrage/core/model/ligneFinancement/ligneFinancement";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LigneFinancementProduit } from 'src/app/parametrage/core/model/ligneFinancement/ligneFinancementProduit';
import { LigneFinancementProduitService } from 'src/app/parametrage/core/service/ligne-financement/ligne-financement-produit.service';
import { LigneFinancementSecteurService } from 'src/app/parametrage/core/service/ligne-financement/ligne-financement-secteur.service';
import { LigneFinancementSecteur } from 'src/app/parametrage/core/model/ligneFinancement/ligneFinancementSecteur';

@Component({
  selector: "app-add-ligne-financement-produit",
  templateUrl: "./add-ligne-financement-produit.component.html",
  styleUrls: ["./add-ligne-financement-produit.component.scss"]
})
export class AddLigneFinancementProduitComponent implements OnInit {
  ligneFinancement: LigneFinancementProduit = new LigneFinancementProduit();

  ligneFinancementSecteur: LigneFinancementSecteur[];

  form2: FormGroup;
  pressButton: Boolean = false;
  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _ligneFinancementProduitService: LigneFinancementProduitService,
    private _ligneFinancementSecteurService: LigneFinancementSecteurService,

    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      montant: [null, Validators.compose([Validators.nullValidator])],
      libelle: [null, Validators.compose([Validators.required])],
      ligneFinancementSecteurId: [
        null,
        Validators.compose([Validators.required])
      ]
    });
  }

  ngOnInit() {
    this.getAll();
  }

  save(): void {
    this.pressButton = true;
    this.ligneFinancement = this.form2.value;

    this._ligneFinancementProduitService
      .add(this.ligneFinancement)
      .pipe(first())
      .subscribe(
        data => {
          this.pressButton = false;
          this.activeModal.close();
        },
        error => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  getAll() {
    this._ligneFinancementSecteurService
      .getAllLigneFinancementSecteur()
      .subscribe(
        data => {
          this.ligneFinancementSecteur = data;
        },
        error => {
          console.log(error);
        }
      );
  }
}
